import { GalleryState } from 'editor/src/store/gallery/types';

const unselectAllImagesReducer = (state: GalleryState) => {
  state.selectedImagesIds = [];
};

export default unselectAllImagesReducer;
